import isEqual from 'react-fast-compare';
import {useSelector} from 'react-redux';

export default function useColumnDefs(columnNamespace) {
    return useSelector(({columnDefs}) => columnDefs[columnNamespace], isEqual);
}
